// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Journal items container */
.JournalItems_journal-items-container__\\+rC6k {
  max-width: 400px;
  margin: 0 auto;
  padding: 10px;
  max-height: 200px;
  overflow-y: auto;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 8px;
}
.JournalItems_journal-items-container__\\+rC6k::-webkit-scrollbar {
  width: 8px;
}
.JournalItems_journal-items-container__\\+rC6k::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 4px;
}
.JournalItems_journal-items-container__\\+rC6k .JournalItems_journal-items-content__AL8jo {
  padding-right: 20px;
}

/* Individual journal item */
.JournalItems_journal-item__HUVED {
  margin-bottom: 10px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}
.JournalItems_journal-item__HUVED:hover {
  background-color: #eaeaea;
}
.JournalItems_journal-item__HUVED .JournalItems_journal-link__r2N11 {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: bold;
}
.JournalItems_journal-item__HUVED .JournalItems_timestamp__\\+c8fc {
  color: #999;
  font-size: 14px;
}

/* No journal items message */
.JournalItems_no-journal-items__91\\+nR {
  text-align: center;
  margin: 20px 0;
}
.JournalItems_no-journal-items__91\\+nR p {
  color: #555;
  font-size: 18px;
  font-style: italic;
}

/* Search bar styles */
.JournalItems_search-bar__DHVwA {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  opacity: 0;
  transition: background-color 0.3s ease, opacity 0.3s ease;
  position: relative;
  top: 0;
  z-index: 1;
  display: none;
}
.JournalItems_search-bar__DHVwA.JournalItems_show__wc8K0 {
  display: block;
  opacity: 1;
  width: 90%;
}

/* Scroll up hint */
.JournalItems_scroll-up-hint__xgFN- {
  position: absolute;
  top: 0;
  width: 100%;
  text-align: center;
  background-color: #f1f1f1;
  color: #333;
  padding: 5px 0;
  font-size: 14px;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/Components/JournalItems/JournalItems.module.scss"],"names":[],"mappings":"AAAA,4BAAA;AACA;EACE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AACF;AACE;EACE,UAAA;AACJ;AAEE;EACE,sBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;;AAKA,4BAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sCAAA;AAFF;AAIE;EACE,yBAAA;AAFJ;AAKE;EACE,qBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AAHJ;AAME;EACE,WAAA;EACA,eAAA;AAJJ;;AAQA,6BAAA;AACA;EACE,kBAAA;EACA,cAAA;AALF;AAOE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;AALJ;;AASA,sBAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,yDAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;AANF;AAQE;EACE,cAAA;EACA,UAAA;EACA,UAAA;AANJ;;AAWA,mBAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;AARF","sourcesContent":["/* Journal items container */\n.journal-items-container {\n  max-width: 400px;\n  margin: 0 auto;\n  padding: 10px;\n  max-height: 200px;\n  overflow-y: auto;\n  position: relative;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #ccc;\n    border-radius: 4px;\n  }\n\n  .journal-items-content {\n    padding-right: 20px;\n  }\n}\n\n/* Individual journal item */\n.journal-item {\n  margin-bottom: 10px;\n  padding: 10px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: #eaeaea;\n  }\n\n  .journal-link {\n    text-decoration: none;\n    color: #333;\n    font-size: 16px;\n    font-weight: bold;\n  }\n\n  .timestamp {\n    color: #999;\n    font-size: 14px;\n  }\n}\n\n/* No journal items message */\n.no-journal-items {\n  text-align: center;\n  margin: 20px 0;\n\n  p {\n    color: #555;\n    font-size: 18px;\n    font-style: italic;\n  }\n}\n\n/* Search bar styles */\n.search-bar {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 16px;\n  outline: none;\n  opacity: 0;\n  transition: background-color 0.3s ease, opacity 0.3s ease;\n  position: relative;\n  top: 0;\n  z-index: 1;\n  display: none;\n\n  &.show {\n    display: block;\n    opacity: 1;\n    width: 90%;\n  }\n}\n\n\n/* Scroll up hint */\n.scroll-up-hint {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  text-align: center;\n  background-color: #f1f1f1;\n  color: #333;\n  padding: 5px 0;\n  font-size: 14px;\n  z-index: 2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"journal-items-container": `JournalItems_journal-items-container__+rC6k`,
	"journal-items-content": `JournalItems_journal-items-content__AL8jo`,
	"journal-item": `JournalItems_journal-item__HUVED`,
	"journal-link": `JournalItems_journal-link__r2N11`,
	"timestamp": `JournalItems_timestamp__+c8fc`,
	"no-journal-items": `JournalItems_no-journal-items__91+nR`,
	"search-bar": `JournalItems_search-bar__DHVwA`,
	"show": `JournalItems_show__wc8K0`,
	"scroll-up-hint": `JournalItems_scroll-up-hint__xgFN-`
};
export default ___CSS_LOADER_EXPORT___;
